import { CallEffect, SelectEffect, call, select } from "redux-saga/effects";
import {
  customerDateOfBirthSelector,
  customerNinSelector,
} from "./userIdentificationSelectors";

import { isAgedBetween18And99 } from "@storebrand-digital/storebrand-common-validation";
import { isAdvisorSelector } from "Store/advisor/advisorSelectors";
import { getCmId, getNin, isAuthenticated } from "Utils/KeycloakWrapper";
import { useSelector } from "react-redux";

export const useCustomerNin = (): string | undefined => {
  return isAuthenticated() ? getNin() : useSelector(customerNinSelector);
};

export const useCustomerCmId = (): string | undefined => {
  return isAuthenticated() ? getCmId() : undefined;
};

export const useCustomerDateOfBirth = (): string | undefined =>
  useSelector(customerDateOfBirthSelector);

export function* getCustomerNinInSaga(): Generator<
  SelectEffect | CallEffect<unknown>,
  string,
  string | boolean
> {
  const isAdvisor = yield select(isAdvisorSelector);
  if (isAdvisor) {
    return (yield select(customerNinSelector)) as string;
  }
  return (yield isAuthenticated()
    ? call(getNin)
    : select(customerNinSelector)) as string;
}

export const useCustomerIsOldEnough = (): boolean => {
  return isAgedBetween18And99(useCustomerNin());
};
